import { render, staticRenderFns } from "./MobileTopHeader.vue?vue&type=template&id=08553f62&"
import script from "./MobileTopHeader.vue?vue&type=script&lang=ts&"
export * from "./MobileTopHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports